const vehicles = ['Automovil', 'Motocicleta', 'Comercial'];

export default vehicles;
